import React from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';

const { RangePicker: AntdRangePicker } = AntdDatePicker;

export const RangePicker: React.FC<RangePickerProps> = ({ ...rest }) => {
  return <AntdRangePicker {...rest} />;
};
